import { generatePath } from 'react-router';

export enum EmployeeViewModules {
  People = 'people',
  Rewarding = 'rewarding',
  Performance = 'performance',
  Development = 'development',
}

export const getEmployeeModuleTabPath = (
  employeeId: number,
  module?: EmployeeViewModules,
  tab?: string,
) => {
  if (!!module && !!tab) {
    return generatePath('/portal/employee/:employeeId/:module/:tab', {
      employeeId,
      module,
      tab,
    });
  } else if (!!module) {
    return generatePath('/portal/employee/:employeeId/:module', {
      employeeId,
      module,
    });
  }

  return generatePath('/portal/employee/:employeeId/', {
    employeeId,
  });
};
